// extracted by mini-css-extract-plugin
module.exports = {"no_data_container":"index-no_data_container__hhgWB","ranking_report_page":"index-ranking_report_page__6PgZ-"};